import { render, staticRenderFns } from "./WidgetBrand.vue?vue&type=template&id=5c115c33&scoped=true&"
import script from "./WidgetBrand.vue?vue&type=script&lang=ts&"
export * from "./WidgetBrand.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetBrand.vue?vue&type=style&index=0&id=5c115c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c115c33",
  null
  
)

export default component.exports